import {AfterViewInit, Component, ViewChild, OnInit, ElementRef} from '@angular/core';
import {MatPaginator, MatPaginatorModule,MatPaginatorIntl } from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import { PeticionesService } from '../servicios/httpservice';
import { AlertifyService } from '../alertify.service';
import { ActivatedRoute, Router } from '@angular/router';

import {LocalStorageService} from 'ngx-webstorage';
import { DataDBService } from '../servicios/data-db.service';
import Swal from 'sweetalert2';

import { FiltrosService } from '../servicios/filtros.service';
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}


@Component({
  selector: 'app-partner-mispedidos',
  templateUrl: './partner-mispedidos.component.html',
  styleUrls: ['./partner-mispedidos.component.css']
})
export class PartnerMispedidosComponent implements OnInit {

  displayedColumns: string[] = ['position',  'fecha', 'weight','cliente', 'telefono', 'correo', 'origen_pago', 'estatus_pago','referencia_pago','idPedidoIntel', 'detalle'];
  //dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  dataSource = new MatTableDataSource<any>(); // Fuente de datos para la tabla
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('cerrarModal') cerrarModal!: ElementRef;
  
  public isHoveredButton:boolean=true;
  public boolSpinner : boolean = false;
  public objPedido:any={};
  public arrayPedidos:any=[];
  public arrayPedidos_original:any=[];
  private strConexion:string;
  public strfechaRequerida: string;
  public strReferencia: string = "";
  public strObservaciones: string = "";
  public NombrePeriodo:string = "";
  public strOrdenCompra: string = "";
  public strComentarios: string = ""; 
  public strUsuarioInt:string=""; 
  public isLoading:boolean=false;
  public strBuscarCte:string='';
  public objCte:any={};
  public arrayPeriodo:any= [];
  public arrayEjercicio:any=[];
  public strEstatus:string='';
  public arrayEstatus: any=[];
  public intEjercicio:number=0;
  public intPeriodo:number; 
  public tagName:string;
  public arrayAccesos:any=[];
  public arrayDescuentos:any =[];
  public objEnvioPartner:any ={};
  public strTipo_envio_partner:string='';
  public strTitulo_envio:string='';
  public strNombre_envio_partner:string='';
  public strAlmacen:string;
  public strCteenviar:string;
  public objPartner:any;
  public objClienteDatos:any;
  public objComentario:any={};
  public strCliente:string="";
  public strNumCte:string;
  public strAgenteLS:string;
  public strAgente_Crea:string;
  public strUsuario:string;
  public strSSN:string;
  @ViewChild('btnCerrarModalPedido') btnCerrarModalPedido!: ElementRef;
  constructor(private router: Router,private indexedDBService: DataDBService,elem:ElementRef, private localSt:LocalStorageService,
    private _httpService: PeticionesService,private route: ActivatedRoute,public _alertify: AlertifyService, 
    private _filtroServ :FiltrosService,private paginatorIntl: MatPaginatorIntl)
   { 


    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.arrayAccesos = value ? value : [];
        if (this.arrayAccesos.length > 0) {
            this.objEnvioPartner=this.arrayAccesos[0].detalle_envio_partner?this.arrayAccesos[0].detalle_envio_partner:{}
            this.strTipo_envio_partner=this.arrayAccesos[0].strTipo_envio_partner?this.arrayAccesos[0].strTipo_envio_partner:'PICKUP';
            this.strNombre_envio_partner = this.arrayAccesos[0].nombre_envioPartner ?  this.arrayAccesos[0].nombre_envioPartner:'';
            this.strTitulo_envio = this.strTipo_envio_partner == 'PICKUP' ? 'Pick Up'  :'Envío Estándar';
            this.strCteenviar =  this.objEnvioPartner.intId_Direccion ?  this.objEnvioPartner.intId_Direccion:null;
          var objAcceso = this.arrayAccesos[0] //this.arrayAccesos.filter((o: any) => o.strComponente == this.tagName);
          console.log(objAcceso)
          if (objAcceso.length == 0) {
            this.router.navigate(['/login']);
          } else {
            let objData = this.arrayAccesos.length >0? this.arrayAccesos[0]:{}
            this.objClienteDatos =  this.arrayAccesos.length >0? this.arrayAccesos[0]:{}
            this.strConexion = this.localSt.retrieve('strConexion');
            this.strAgenteLS = objData.strAgente ; //this.localSt.retrieve('strAgente');
            this.strAgente_Crea = objData.strAgente; // this.localSt.retrieve('strAgente');
            this.strUsuario = objData.strUsuario;
            this.strCliente = objData.strCliente
            this.strSSN =  objData.strSSN;
            //------------conexi+on-------------------
            this.indexedDBService.getItem('strConexion', (value) => {
              this.strConexion = value;
            });
            this.fnGetPedidos();
            this.fnCambioNombrePaginador();
            /* this.fnGetCupones() */
          }
        } else {
          this.router.navigate(['/login']);
        }
      });  
   }


ngOnInit(): void {
    let fecha = new Date(); 
    this.intEjercicio = fecha.getFullYear();
    this.intPeriodo = fecha.getMonth()+ 1; 
    this.arrayEstatus = [{strEstatus: 'PAGADO'}, {strEstatus: 'PENDIENTE'}, {strEstatus: 'PROCESO'},{strEstatus: 'NEW'} ,{strEstatus:  'ACTIVE'}];
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.strConexion = this.localSt.retrieve('strConexion');

      this.strBuscarCte='WECE1';
      this.fnBuscarCliente(this.strBuscarCte);
      this.fnGetFiltros()
      this.fnGetPedidos();
    })
    
  }

  ngAfterViewInit() {
    this.fnTablePartner()
  }
    
  fnCambioNombrePaginador() {
      this.paginatorIntl.itemsPerPageLabel = 'Pedidos por página';
    }
    fnTablePartner() {
      this.dataSource.paginator = this.paginator;
      //this.dataSource.sort = this.sortSolicitud;
    }
  
    fnGetFiltros(){
      this._filtroServ.array_Periodos_$.subscribe((nuevoValor) => {
        this.arrayPeriodo = nuevoValor;
      });
      this._filtroServ.array_Ejercicios_$.subscribe((nuevoValor) => {
        this.arrayEjercicio = nuevoValor;
      });
    }
    fnBuscarCliente(cliente:string){
      let objBuscar = {
        strAccion: "getDataCte", 
        strConexion: this.strConexion,
        strCliente:cliente
      };
      this._httpService.mostrarCotizaciones(objBuscar, 'sp_ECommerce').subscribe(
        result => { 
         if(result[0]){
          this.objCte=result[0];
         }
         else {
          this.objCte={};
          Swal.fire({
            icon:   'error',
            title: 'Error',
            text: 'No se encontró información relacionada al cliente seleccionado',
            confirmButtonText: 'Cerrar'
          });
         }
        },error=>{
          console.log(error.message) 
        });
    }

    fnGetPedidos(){

      let periodo = this.arrayPeriodo.find(x => x.strPeriodo === this.intPeriodo);
      this.boolSpinner = true
      this.NombrePeriodo = periodo ? periodo.strNombre : ''
      this.arrayPedidos = [];
      let articulo = {
        strAccion: "getPartner_PedidoPag",
        strConexion: this.strConexion,
        strCliente:this.strCliente ,
        intEjercicio:this.intEjercicio,
        intPeriodo:this.intPeriodo
      };
      this._httpService.mostrarCotizaciones(articulo, 'sp_ECommerce').subscribe(
        result => { 
         this.arrayPedidos_original = result;
          if(result){
           let uniquePedidos=[]
             result.forEach(element => {
              let objB = uniquePedidos.find(o=>o.intID_Pedido ==element.intID_Pedido)
              if(!objB){
                uniquePedidos.push(element)
              }
            });
            this.arrayPedidos =uniquePedidos;
            this.dataSource.data = this.arrayPedidos;
            this.boolSpinner = false
            this.fnTablePartner();
          }
        
          this.boolSpinner = false
        
       
        },error=>{
          this.boolSpinner = false
          console.log(error.message) 
        });
    }
    fnGetDetalle(intID_Pedido:number){
      this.objPedido={}
      this.objPedido.arrayArticulos=[];
      let arrayArticulos = this.arrayPedidos_original.filter(o=>o.intID_Pedido== intID_Pedido);
      this.objPedido=arrayArticulos[0]
      this.objPedido.arrayArticulos=arrayArticulos;
      let total =0
      arrayArticulos.forEach(element => {
        total=total + (element.dblPrecioLista * element.dblCantidad)
      });
      this.objPedido.total=total;
      this.strBuscarCte=this.objPedido.strCliente;
      this.fnBuscarCliente(this.strBuscarCte)
    }
    setPedido(){
      this.isLoading = true;
      let strIDSucursal =null; // this.objCliente.intIDSucursal > 0 ? this.objCliente.intIDSucursal : null;
      let strCliente =  this.objCte.strCliente;//'WECE1'; 
      let strSucursal =  '60';
      let agente =  '599';
      let strCondicion = 'PContado'//this.objCliente.strCondicion;
      let alm =  '1';
      this.strComentarios = this.objPedido.strDireccion +', col. '+ this.objPedido.strColonia + '. '+ this.objPedido.strCiudad+', '+ this.objPedido.strEstado+', '+ this.objPedido.strPais +'. cp.'+ this.objPedido.strCodigoPostal
      this.strObservaciones= this.objPedido.strDireccion +', col. '+ this.objPedido.strColonia + '. '+ this.objPedido.strCiudad+', '+ this.objPedido.strEstado+', '+ this.objPedido.strPais +'. cp.'+ this.objPedido.strCodigoPostal
      
      this.strOrdenCompra = this.objPedido.intID_Pedido;
      this.strUsuarioInt='ECOMERCE';
      this.strReferencia=this.objPedido.strReferencia_Pago;
      let xmlArticulos = [];
      console.log(this.objPedido.arrayArticulos);
      this.objPedido.arrayArticulos.forEach(element =>{
        console.log( " hay este valor: " + element);
        let precio =(element.dblPrecioLista/1.16)
        xmlArticulos.push({ strArticulo: element.strArticulo, dblPrecio: precio, intCantidad: element.dblCantidad, strOpcion: element.strOpcion });
      });
      
      const fecha: Date = new Date();
      fecha.setDate(fecha.getDate() + 1);
      const dia = fecha.getDate().toString().padStart(2, '0'); // Obtiene el día y lo ajusta al formato 'dd'
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Obtiene el mes (se suma 1 porque los meses son base 0) y lo ajusta al formato 'mm'
      const anio = fecha.getFullYear();
      let strFechaRequerida = dia + '/' + mes + '/' + anio
      console.log("Esta es la fecha requerida que se esta enviando: " + strFechaRequerida);
      console.log("Este es el agente enviando: " + agente);
      console.log("Este es el cliente al que se esta enviando: " + strCliente);
      console.log("Esta es id sucursal que se envia: " + strIDSucursal);
      console.log("Esta es a la sucursal que se envia: " + strSucursal);
      console.log(" referencia que se envia: (50 caracteres)" + this.strReferencia);
      console.log("ordencompra que se envia: " + this.strOrdenCompra);
      console.log("comentarios que se envia: text" + this.strComentarios);
      console.log("observaciones que se envia: (100 caracteres)" + this.strObservaciones);
      console.log("strCondicion que se envia: " + strCondicion);
      console.log("almacen que se envia: " + alm);
      console.log("articulos que se envia: ");
      console.log(xmlArticulos);
   
      this._httpService.setPedido({
        strAccion: 'setPedido',
        strAgente: agente,
        strCliente: strCliente,
        strSucursal: strSucursal,
        xmlArticulos: xmlArticulos,
        strCteEnviarA: strIDSucursal,
        strFechaRequerida: strFechaRequerida,
        strOrdenCompra: this.strOrdenCompra,
        strReferencia: this.strReferencia,
        strObservaciones: this.strObservaciones,
        strComentarios: this.strComentarios,
        strSistema: 'TIENDA_ECODELI',
        strCondicion: strCondicion,
        strAlmacen: alm,
      //  strArchivo_orden_compra: this.nombreOrdenCompra,
        strConexion: this.strConexion,
        strUsuario: this.strUsuarioInt
      }).subscribe(
        result => {
          
          let pruebas = [];
          pruebas = result;
          let code = pruebas.length == 0 ? 410 : pruebas[0] ? pruebas[0].code : 410;
          let msj = pruebas.length == 0 ? 'Ocurrió un error al intentar generar el pedido' : pruebas[0] ? pruebas[0].strMensaje : 'Ocurrió un error al intentar generar el pedido';
          let strMensaje = msj;
          let titulo = code == 409 ? 'Pedido Generado SINAFECTAR' : code == 200 ? 'Pedido Generado Correctamente' : 'Error al Intentar Generar Pedido';
          Swal.fire({
            icon: code == 409 ? 'warning' : code == 200 ? 'success' : 'error',
            title: titulo,
            text: msj,
            confirmButtonText: 'Cerrar'
          });
          console.log(pruebas);
          if (code==200 || code==409){
            this.isLoading = false;
          //recargar pedidos
            this.fnGetPedidos();
          }
          else{
            this.isLoading = false;
          }
           
          this.btnCerrarModalPedido.nativeElement.click();
        },
        error => {
      
          var error = <any>error;
          console.log(error);
          // object.spinner = false;
          Swal.fire({
            icon: 'error',
            title: 'Uuups...',
            text: 'Error en conexion al insertar pedido'
          });
        }
      );  
    }
    fnEliminarPedido(intID_Pedido:number){
      this.arrayPedidos = [];
      let articulo = {
        strAccion: "deletePedido_PARTNER", 
        strConexion: this.strConexion,
        intID_Pedido: intID_Pedido 
      };
      this._httpService.mostrarCotizaciones(articulo, 'sp_ECommerce').subscribe(
        result => {
         console.log(result) 
          if(result[0] && result[0].code == "200"){
            Swal.fire({
                       title: "Eliminado correctamente",
                       text: result[0].strMensaje,
                       icon: "success"
                     });
  
                     this.fnGetPedidos();
          }
          else {
            Swal.fire({
              title: "Ocurrió un error ",
              text: 'Error al intentar eliminar el pedido',
              icon: "success"
            });
          }
        },error=>{
          console.log(error.message) 
        });
    }

    fnIngresarComentario(){
      let objComentario = {
        strAccion: "setComentarioPart", 
        strConexion: this.strConexion,
        intID_Pedido:this.objComentario.intID_Pedido,
        strObservaciones:this.objComentario.strObservaciones
      };
      console.log(objComentario)
      this._httpService.mostrarCotizaciones(objComentario, 'sp_ECommerce').subscribe(
        result => { 
          console.log(result)
         if(result[0].code == 200){
          Swal.fire({
            icon:   'success',
            title: 'Guardado',
            text: result[0].strMensaje,
            timer: 2500, 
            timerProgressBar: true,
            showConfirmButton: false
          });
          this.fnGetPedidos()
          this.objComentario = {}
          this.cerrarModal.nativeElement.click()
         } else if(result[0].code == 409) {
    
          Swal.fire({
            icon:   'error',
            title: 'Error',
            text: result[0].strMensaje,
            confirmButtonText: 'Cerrar'
          });
         }
        },error=>{
          console.log(error.message) 
        });
    }
  fnComentario(row:any){
    console.log(row)
    this.objComentario = {}
    this.objComentario = row;
    this.objComentario.strObservaciones = row.strObservaciones != null && row.strObservaciones != ""?row.strObservaciones:"";
  }

}
 